import React, { useEffect, useRef } from "react";
import { shiftCode, SHIFT_COLOR_COUNT } from "./shiftUtils";

export default function CellPopover({ anchorRect, shiftTemplates, onApplyShift, onApplyOverride, onClear, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    function onDown(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [onClose]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      const n = Number(e.key);
      if (n >= 1 && n <= shiftTemplates.length) {
        e.preventDefault();
        onApplyShift(shiftTemplates[n - 1]);
      }
      if (e.key === "0") { e.preventDefault(); onClear(); }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [shiftTemplates, onApplyShift, onClear, onClose]);

  if (!anchorRect) return null;

  // Position: below the anchor cell, or above if near bottom
  const popoverWidth = 220;
  const spaceBelow = window.innerHeight - anchorRect.bottom;
  const top = spaceBelow > 160 ? anchorRect.bottom + 4 : anchorRect.top - 4;
  const translateY = spaceBelow > 160 ? 0 : -100;
  const left = Math.min(anchorRect.left, window.innerWidth - popoverWidth - 8);

  return (
    <div
      ref={ref}
      className="roster-popover"
      style={{ top, left, transform: `translateY(${translateY}%)` }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="roster-popover-section">
        {shiftTemplates.map((shift, idx) => {
          const colorIndex = idx % SHIFT_COLOR_COUNT;
          return (
            <button
              key={shift.id}
              className={`roster-popover-shift range-color-${colorIndex}`}
              onClick={() => onApplyShift(shift)}
              title={`${shift.name} (${shift.workStartTime}–${shift.workEndTime}) [${idx + 1}]`}
            >
              {shiftCode(shift.name, shiftTemplates)}
              <span className="roster-popover-shift-label">{shift.name}</span>
            </button>
          );
        })}
      </div>
      <div className="roster-popover-divider" />
      <div className="roster-popover-section roster-popover-overrides">
        <button className="roster-popover-override leave" onClick={() => onApplyOverride("OFF")}>
          L Leave
        </button>
        <button className="roster-popover-override half" onClick={() => onApplyOverride("HALF_DAY")}>
          ½ Half day
        </button>
        <button className="roster-popover-override working" onClick={() => onApplyOverride("WORKING")}>
          + Force on
        </button>
        <button className="roster-popover-override clear" onClick={onClear}>
          ✕ Clear [0]
        </button>
      </div>
    </div>
  );
}
